import React from 'react';
import {
  Shield,
  ScrollText as Feed,
  Plus,
  CalendarCheck,
  MessageSquare,
  Layers,
} from 'lucide-react';
import { SneakerMove } from '@phosphor-icons/react'; // ✅ Correct import
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

const iconComponents = {
  Shield,
  Feed,
  Plus,
  CalendarCheck,
  MessageSquare,
  Layers,
  SneakerMove, // ✅ Add it to the icon map
};

interface BottomNavItemProps {
  label: string;
  icon: keyof typeof iconComponents;
  isActive?: boolean;
  count?: number;
  onClick: () => void;
  isSpecial?: boolean;
  className?: string;
}

const BottomNavItem: React.FC<BottomNavItemProps> = ({
  label,
  icon,
  isActive,
  count,
  onClick,
  isSpecial,
  className,
}) => {
  const Icon = iconComponents[icon];

  const specialButtonVariants = {
    tap: { scale: 0.9 },
    hover: { scale: 1.1 },
  };

  return (
    <button
      onClick={onClick}
      className={cn(
        'relative flex flex-col items-center justify-center w-16 py-1',
        isActive ? 'text-gold-400' : 'text-dark-800 hover:text-white',
        className
      )}
    >
      <div className="relative">
        {isSpecial ? (
          <motion.div
            className="w-14 h-14 bg-gold-400 rounded-full shadow-lg flex items-center justify-center hover:bg-gold-500 transition-all duration-300"
            whileHover={specialButtonVariants.hover}
            whileTap={specialButtonVariants.tap}
            initial={{ scale: 1 }}
          >
            <Icon className="h-7 w-7 text-dark-50" />
            <motion.div
              className="absolute inset-0 bg-gold-400 rounded-full"
              initial={{ scale: 1, opacity: 0 }}
              whileTap={{
                scale: 1.4,
                opacity: 0,
                transition: { duration: 0.4 },
              }}
              transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            />
          </motion.div>
        ) : (
          <Icon className="h-6 w-6 mb-1" />
        )}
        {typeof count === 'number' && count > 0 && !isSpecial && (
          <span
            className={cn(
              'absolute -top-1 -right-1 min-w-[18px] h-[18px]',
              'flex items-center justify-center',
              'bg-gold-400 text-dark-50 text-[10px] font-medium rounded-full',
             'px-1 -right-3'
            )}
          >
            {count}
          </span>
        )}
      </div>
      <span className="text-[10px] leading-none mt-1">{label}</span>
    </button>
  );
};

export default BottomNavItem;
